$(document).ready(function () {
	
	$('.key-figures-boxes').each(function () {

		$(this).find('.buttons-wrapper button').click(function () {
			$('.buttons-wrapper button').removeClass('active');
			$(this).addClass('active');
			$('.facts-wrapper').hide();
			$($(this).data('facts-wrapper')).fadeIn('slow');
		});

		console.log ($(this).find('.facts-wrapper').length);
		if ($(this).find('.facts-wrapper').length > 1) {
			$(this).find('.facts-wrapper').hide();
		}
		
		$('.buttons-wrapper button.active').each(function () {
			$($(this).data('facts-wrapper')).fadeIn('slow');
		});

		$('.facts-wrapper').each(function () {
			console.log(this);
			$(this.class + ' .slider-wrapper').slick({
				infinite: false,
				slidesToShow: 3,
				arrows: true,
				nextArrow: ".next-wrapper",
				prevArrow: ".prev-wrapper",
				responsive: [
					{
						breakpoint: 1098,
						settings: {
							slidesToShow: 2,
							arrows: false,
							dots: true,
							appendDots: ".slider-dots"
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							dots: true,
							appendDots: ".slider-dots"
						}
					}
				]
			});
		});
	});
});
